import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AppEnvironment } from 'sham-components/services';
import {
  LoginResponseDto,
  SigninSubmitRequest,
} from 'sham-components/shared/models/auth';
// import { API_BASE_URL } from '@/environments/environment';

@Injectable({ providedIn: 'root' })
export class SigninApi {
  appEnv = inject(AppEnvironment);
  private readonly http = inject(HttpClient);

  API_BASE_URL = this.appEnv.API_BASE_URL();

  login(payload: SigninSubmitRequest): Observable<LoginResponseDto> {
    return this.http.post<LoginResponseDto>(
      `${this.API_BASE_URL}/api/v1/auth/login`,
      payload,
    );
  }

  refreshToken(payload: { refreshToken: string }): Observable<LoginResponseDto> {
    return this.http.post<LoginResponseDto>(
      `${this.API_BASE_URL}/api/v1/auth/refresh-token`,
      payload,
    );
  }
}
